import {
  type Apartment,
  type ApartmentRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';
import { withBuildingRealEstate } from './shared-building-realestate';

const baseHandler = createBaseRentHandler<Apartment, ApartmentRevenueRow>(
  'apartmentrevenuerow'
);

export async function handleCustomApartmentNestedCase(
  listResponse: Parameters<typeof baseHandler>[0]
) {
  const withRevenue = await baseHandler(listResponse);
  return withBuildingRealEstate(withRevenue);
}
